import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FunctionService {

  constructor(private http:HttpClient) { }
  getAllergens(){
    return this.http.get<any[]>(environment.apiUrl+"functions");
  }
}
